// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__msxrs","logoText":"styles_logoText__Pq71a","logoIcon":"styles_logoIcon__BHbPE"};